module.exports = __webpack_public_path__ + "static/intro-music-3d6ed611ebda0db60e411d52cd4c9f7d.mp3";